const styleVars = {
  /* site wide variables */
  backgroundColor: "rgb(220, 249, 255)",
  colorP1: "#f0f5ff",
  colorP2: "#6d9cf9",
  colorP3: "#3a76eb",
  colorP4: "#cedfff",
  colorP5: "#1b57cc",
  heatmap1: "#f0f5ff",
  heatmap2: "#cedfff",
  heatmap3: "#adc9ff",
  heatmap4: "#6d9cf9",
  heatmap5: "#3a76eb",
  heatmap6: "#1b57cc",
  heatmap7: "#0a3da2",
  heatmap8: "#02266d",
  heatmap9: "#001133"
};

export default styleVars;
